import React from 'react';
import {Typography} from '@mui/material';
import {typografNode} from '../../utils/typograf';

type ButtonLabelProps = {
    children: React.ReactNode;
    className?: string;
    comfortable?: boolean;
};

function ButtonLabel({children, className, comfortable}: ButtonLabelProps) {
    return (
        <Typography className={className} sx={{
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: comfortable ? 1.71 : 1.6,
            letterSpacing: '1px',
            textTransform: 'uppercase',
            '@media screen and (max-width: 1399px)': {
                lineHeight: 1.71,
            },
        }}>{typografNode(children)}</Typography>
    );
}

export default ButtonLabel;
